import CommonAppbar from '../components/common/CommonAppbar';
import {useParams} from 'react-router-dom';
import {useEffect, useState} from 'react';
import QuestionCard from '../components/QuesAndAns/QuestionCard';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {FILTERED_POLLS_TYPES} from '../constants/appConstants';
import SwipeableViews from 'react-swipeable-views';
import Filters from '../components/Filters';

function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FilteredPolls() {
  let {id} = useParams();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    window.scrollTo(0, 0)
    const index = Object.entries(FILTERED_POLLS_TYPES).findIndex(([elKey, elValue]) => elValue === id)
    setValue(index)
  }, [id])

  return <>
    <CommonAppbar isMainPage={false} pageHeader={id}/>
    <Box sx={{width: '100%'}}>
      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs value={value} onChange={handleChange} aria-label="activities tabs example">
          {Object.entries(FILTERED_POLLS_TYPES).map(([filteredPollKey, filteredPollValue]) => {
            return <Tab label={filteredPollValue} {...a11yProps(0)} />
          })}
        </Tabs>
      </Box>

      <SwipeableViews index={value} onChangeIndex={(newIndex => {
        setValue(newIndex)
      })}>
        {Object.entries(FILTERED_POLLS_TYPES).map(([filteredPollKey, filteredPollValue], index) => {
          const isMyPolls = FILTERED_POLLS_TYPES.CREATED_POLLS === filteredPollValue
          return <CustomTabPanel value={value} index={index}>
            <Filters/>
            <QuestionCard showEditOption={true} withBoost={isMyPolls}/>
          </CustomTabPanel>
        })}
      </SwipeableViews>
    </Box>
  </>
}
